import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'lab-ds-text-field-with-tag',
  styleUrl: 'lab-ds-text-field-with-tag.css',
  shadow: true,
})
export class LabDsTextFieldWithTag {
  @Prop() optionsSelected: Array<{ label: string; key: string; nameAvatar?: string; imgSRCAvatar?: string }>;

  @Prop() value!: string;

  @Prop() titleInput: string = '';

  @Prop() label: string = '';

  @Prop() avatar: boolean = true;

  @Prop() labelIcon: string = '';

  @Prop() disabled: boolean = false;

  @Prop() helperText: string = '';

  @Prop() state: 'error' | 'success' | 'default' = 'default';

  @Event() changeInput: EventEmitter<string>;

  @Event() changeInputOption: EventEmitter<Array<{ label: string; key: string; nameAvatar?: string; imgSRCAvatar?: string }>>;

  handleChange(event) {
    this.changeInput.emit(event.target.value);
    this.value = event.target.value;
  }

  handleRemoveOption(event) {
    this.optionsSelected = this.optionsSelected.filter(option => option.label !== event);
    this.changeInputOption.emit(this.optionsSelected);
  }

  handleSubmitInput(event) {
    event.preventDefault();
    const option = {
      label: this.value,
      key: 'string',
    };

    this.optionsSelected?.length > 0 ? (this.optionsSelected = [...this.optionsSelected, option]) : (this.optionsSelected = [option]);

    this.changeInput.emit('');
    this.changeInputOption.emit(this.optionsSelected);
    this.value = '';
  }

  render() {
    const iconHelper = {
      error: { icon: 'error' },
      success: { icon: 'check_circle' },
      default: { icon: '' },
    };

    const slider: HTMLElement = document.querySelector('lab-ds-text-field-with-tag').shadowRoot.querySelector('.chip-group');
    let isDown = false;
    let startX;
    let scrollLeft;

    if (slider) {
      slider.addEventListener('mousedown', (e: MouseEvent) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mousemove', (e: MouseEvent) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
      });
    }

    return (
      <div class={`v4-input ${this.state} ${this.disabled && 'disabled'}`}>
        <span class="title-text">{this.titleInput}</span>
        <div class="input-helper">
          <div class="input-icon">
            {this.labelIcon && <lab-ds-icon-not-selectable class="icon left" size="small" icon={this.labelIcon} />}
            {this.optionsSelected?.length > 0 && (
              <div class="chip-group">
                <div class="chips">
                  {this.optionsSelected?.map(option => (
                    <lab-ds-chip
                      size="small"
                      class="chip"
                      avatar={this.avatar}
                      label={option.label}
                      nameAvatar={option.nameAvatar}
                      imageSRCAvatar={option.imgSRCAvatar}
                      onHandleCloseChip={() => this.handleRemoveOption(option.label)}
                    />
                  ))}
                </div>
              </div>
            )}
            <form
              class="input-field"
              onSubmit={event => {
                this.handleSubmitInput(event);
              }}
            >
              <input
                disabled={this.disabled}
                placeholder={this.label}
                type="text"
                value={this.value}
                onInput={event => {
                  this.handleChange(event);
                }}
              />
            </form>
            <lab-ds-icon-not-selectable class="icon right" size="small" icon={iconHelper[this.state].icon} />
          </div>
          {this.helperText && (
            <span class="helper-text">
              {iconHelper[this.state].icon && <lab-ds-icon-not-selectable class="icon" size="x-small" icon={iconHelper[this.state].icon} />}
              {this.helperText}
            </span>
          )}
        </div>
      </div>
    );
  }
}
